// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"161":"5b2612f8","263":"b53ef899","302":"850ec4cf","367":"031dad58","487":"f739ca69","536":"031dad58","872":"733b0c9f","931":"dd1226e1"}[chunkId] + ".css";
};